import util from '@bmp-vue/core/api/util'

const controller = 'Notificacao'
export default Object.assign({}, util.GetCrud(controller, null), {
    GetNotificacaoOperador: function () {
        return util.Axios.Get(controller + '/NotificacaoOperador')
    },
    NotificacaoExibicao: function(){
        return util.Axios.Get(controller + '/NotificacaoExibicao')
    },
    LerNotificacao: function(codigoNotificacao){
        return util.Axios.Put(controller , codigoNotificacao)
    },
    GetParceirosAtivos: function () {
      return util.Axios.Get(controller + '/ParceirosAtivos')
    },
    GetParceirosNotificacao: function (codigo) {
      return util.Axios.Get(controller + '/ParceirosNotificacao', codigo)
    }
})
